import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { CommonButtonPopup } from '../../components/HealthCoach/styles';
import { fetchApi } from '../../utils/methods';
import { AdminCloseIcon, dropWellnessIcon } from '../../utils/icons';
import { ImageUrl } from '../../utils/constants';
import { toast } from 'react-toastify';
import { CalendarWrapper, ButtonContainer, CalendarHeader  } from '../../components/common/CommonModal/style';
import { InterestCard, StyledModal } from './styles';
import { DropdownContent } from '../../components/UserProfile/styles';
import { Border } from '../../components/RecogntionAdmin/styles';


const EditWellnessHub = ({show,onClose,fetchWellnessHubCategories}) => {

  const [categories, setCategories] = useState({
    article: [],
    recipe: [],
    fitness_video: []
  });
  
  const [selected, setSelected] = useState({
    article: [],
    recipe: [],
    fitness_video: []
  });
  const [open, setOpen] = useState('article');

  useEffect(()=>{
    fetchCategories();
    fetchSelected();
  },[])

  const fetchCategories = async () => {
    try {
      const res = await fetchApi("/v1/getWellnessHubCategories", "GET");
  
      const apiData = res?.data || {};
  
      const newData = {
        article: apiData.article_categories || [],
        recipe: apiData.recipe_categories || [],
        fitness_video: apiData.fitness_video_categories || []
      };
  
      setCategories(newData);
  
    } catch (error) {
      window.console.error("Error fetching categories:", error);
      toast.error("Failed to load categories");
    }
  };


  const fetchSelected = async () => {
    try {
      const res = await fetchApi("/v1/getMyPersonalizedWellnessCategories", "GET");
      const data = res.data || [];
  
      const newSelected = {
        article: [],
        recipe: [],
        fitness_video: []
      };
  
      data.forEach((item) => {
        if (newSelected[item.type]) {
          newSelected[item.type].push(item.id);
        }
      });
  
      setSelected(newSelected);
  
    } catch (error) {
      window.console.error("Error fetching selected categories:", error);
      toast.error("Failed to load selected categories");
    }
  };

  const toggleCategory = (type, id) => {
    setSelected((prev) => {
      const exists = prev[type].includes(id);
  
      if (exists) {
        return { ...prev, [type]: prev[type].filter((x) => x !== id) };
      }
  
      // max 4
      if (prev[type].length >= 4) {
        toast.error("Select maximum 4 options.");
        return prev;
      }
  
      return { ...prev, [type]: [...prev[type], id] };
    });
  };

  
  const handleSave = async () => {
    try {
      const res = await fetchApi("/v1/addUpdateUserPersonalizedWellnessCategories","POST",selected);
  
      if (res.status === "success") {
        toast.success(res?.message);
        fetchWellnessHubCategories();
        onClose();
      }
    } catch (err) {
      window.console.error(err);
    }
  };
      
      
      

  const CategorySection = (title, type) =>  (
    <InterestCard>
      <div className="interest-container" onClick={() => setOpen(open === type ? null : type)}>
        <div className="title">{title}</div>
        <div  style={{transform:  open === type ? "rotate(90deg)" : "rotate(0deg)",transition:"transform 0.3s ease"}} className="dropicon"> {dropWellnessIcon()}</div>
      </div>

      {open === type && (
        <div className="dropdown-wrapper">
          {categories[type]?.map((item) => {
            const isSelected = selected[type]?.includes(item.id);

            return (
              <DropdownContent
                key={item.id}
                userInterest={isSelected}
                onClick={(e) => {e.stopPropagation();toggleCategory(type, item.id);}}
                style={{ cursor: "pointer" }}
                background={"#DA6C74"}
              >
                <img src={`${ImageUrl}/${item.image}`}  className="category-img" style={{borderRadius:'50%'}}/>
                <div className="listContent">{item.category_name}</div>
              </DropdownContent>
            );
          })}
        </div>
      )}
    </InterestCard>
  );

  const isDisabled = !(
    selected?.article?.length >= 2 && selected?.article?.length <= 4 &&
    selected?.fitness_video?.length >= 2 && selected?.fitness_video?.length <= 4 &&
    selected?.recipe?.length  >= 2 && selected?.recipe?.length  <= 4
  );
      
    
  return(
    <StyledModal show={show} width={'800px'}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            {/* <div className="icon">{icon && icon}</div> */}
            <div>{"Edit Wellness Hub"}</div>
          </div>
          <div className="close-icon" onClick={()=>onClose()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <Border background={'#EFEFEF'} height={'0.75px'}/>
        <div className='message'>Choose 2–4 options in each of the 3 wellness categories below.</div>
        <CalendarWrapper>
          {CategorySection("Education","article")}
          {CategorySection("Wellness & Fitness Videos","fitness_video")}
          {CategorySection(" Nutrition Recipes","recipe")}
          {/* <CategorySection title="Article Categories" type="article" />
          <CategorySection title="Recipe Categories" type="recipe" />
          <CategorySection title="Fitness Video Categories" type="fitness_video" /> */}
        </CalendarWrapper>
      </div>
  
      <Modal.Footer style={{borderTop:'none',display:'flex',paddingTop:'0px',justifyContent:'center'}}>
  
        <ButtonContainer>
          <CommonButtonPopup disabled={isDisabled} onClick={handleSave} width={'200px'} margin={"20px 0px 0px 0px"} background={"#DA6C74"}>{"Save"}</CommonButtonPopup>
        </ButtonContainer>
  
      </Modal.Footer>
    </StyledModal>
  )};


EditWellnessHub.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose:PropTypes.func,
  title: PropTypes.bool.isRequired,
  type:PropTypes.func,
  fetchWellnessHubCategories:PropTypes.func
};
  

export default EditWellnessHub;

